import jwtDecode from 'jwt-decode';
import React, {useState, useEffect} from 'react'
import {Route, Redirect} from 'react-router-dom'
import userService from '../services/userapi'
import { getAccessToken, setAccessToken } from '../services/accessToken'


const IsUserLoggedIn = ({component: Component, ...rest}) => {
    let data = JSON.parse(sessionStorage.getItem('user'))
    //console.log("THE USER FOR ", data)
    const [isUserLoggedIn, setisUserLoggedIn] = useState(null)

    const refreshTheToken = async () => {
        //console.log("Refreshing the token")
        return userService.regenerateToken().then(x => {
          //console.log("FOUND REFRESH Private")
          const {accessToken} = x
          setAccessToken(accessToken)
          return accessToken
        })
    }
    useEffect(() => {
        async function checkAuthorization() {
            let token = getAccessToken()
            //console.log("The token for isLoggedIn", token)
            if(token!="" && (data != undefined)){
                console.log("User exists but have invalid token")
                let {exp} = jwtDecode(token)
                let dateNow = new Date();
                //console.log(exp)
                //console.log(dateNow.getTime()/1000)
                if(exp < dateNow.getTime()/1000) {
                    //console.log("Access token has expired")
                    try{
                        const accessT = await refreshTheToken()
                        //console.log("from isLoggedIn route", accessT)
                        if (accessT) {
                            //console.log("retried to fetch refresh token successfully", accessT)
                            setisUserLoggedIn(true)
                        }else{
                            setisUserLoggedIn(false)
                        }
                    }catch(err) {
                        //console.log("Problem with refreshing the token, resign in pls")
                        setisUserLoggedIn(false)
                        }
                        
                }else {
                    console.log("access token is still valid")
                    setisUserLoggedIn(true)
                }
            }else if(token == "" && data){
                console.log("token is empty and user is not")
                const accessT = await refreshTheToken()
                if (accessT) {
                    setisUserLoggedIn(true)
                }else{
                    setisUserLoggedIn(false)
                }
            }
            else{
                //console.log("in the false place")
                setisUserLoggedIn(false)
            }
        }
        checkAuthorization()
    },[])

    if(isUserLoggedIn === null){
        return<></>
    }

    return (
        <Route {...rest} render={props =>
            isUserLoggedIn ? (
              <Redirect to='/Social'/>
            ) : (
              <Component {...props} />
            )
          }
        />
    )
}

export default IsUserLoggedIn